import type { SelectorHandlers } from "app/components/filters-bar/useSelectorTrigger";
import BoxSubtitle from "pro-features/components/BoxSubtitle/src/BoxSubtitle";
import type { FC } from "react";
import CountryService from "app/services/CountryService";
import DurationService from "app/services/DurationService";
import StyledBoxSubtitle from "pro-features/styled components/StyledBoxSubtitle/src/StyledBoxSubtitle";
import { useCurrentStateAndParams } from "@uirouter/react";

export const WidgetSubtitle: FC<
    {
        webSource?: string;
        duration?: string;
    } & SelectorHandlers
> = (props) => {
    const { params } = useCurrentStateAndParams();
    const { country: countryCode } = params;
    const webSource = props.webSource ?? params.webSource;
    const duration = props.duration ?? params.duration;
    const countryName = CountryService.getCountryById(countryCode)?.text;
    const { from, to } = DurationService.getDurationData(duration).forAPI;
    const subtitleFilters = [
        {
            filter: "date",
            value: {
                from,
                to,
            },
            onClick: props.onDateClick,
            onMouseEnter: props.onDateHover,
        },
        {
            filter: "country",
            countryCode,
            value: countryName,
            onClick: props.onCountryClick,
            onMouseEnter: props.onCountryHover,
        },
        {
            filter: "webSource",
            value: webSource,
            onMouseEnter: props.onWebSourceHover,
        },
    ];
    return (
        <StyledBoxSubtitle>
            <BoxSubtitle filters={subtitleFilters} />
        </StyledBoxSubtitle>
    );
};
